import appStore from '@/store';
import { ConnectorSyncStatus } from '@/store/state/ConnectorState';
import { StartConnectorSyncResult } from '@/store/actions/connectorActions';

export const dispatchLoadConnectors = (workspaceId: string) => {
  return appStore.dispatch('loadConnectors', workspaceId);
};
export const dispatchRegisterConnector = (payload: Record<string, unknown>) => {
  return appStore.dispatch('registerConnector', payload);
};
export const dispatchTriggerSync = (connectorId: string) => {
  return appStore.dispatch('triggerSync', connectorId);
};
export const dispatchStartConnectorSync = (connectorId: string): Promise<StartConnectorSyncResult> => {
  return appStore.dispatch('startConnectorSync', connectorId);
};
export const dispatchRefreshSyncStatuses = (connectorIds: string[]): Promise<Record<string, ConnectorSyncStatus>> => {
  return appStore.dispatch('refreshSyncStatuses', connectorIds);
};
export const dispatchDisconnectConnector = (connectorId: string, keepArticles = false) => {
  return appStore.dispatch('disconnectConnector', { connectorId, keepArticles });
};
export const dispatchReconnectConnector = (payload: Record<string, unknown>) => {
  return appStore.dispatch('reconnectConnector', payload);
};
export const dispatchUpdateConnector = (connectorId: string, payload: Record<string, unknown>) => {
  return appStore.dispatch('updateConnector', { connectorId, payload });
};
